import PmbEnterprise from './enterprise';

// Practice Solutions is identical to Enterprise, except for the following:
// - Benefit #5 has been removed
// - Benefit #7 has been removed
class PmbPracticeSolution extends PmbEnterprise {
  service_package_cost() { // Configurator - H49
    return this.input.service_package_cost;
  }

  reduce_time_on_new_sites() {
    return 0;
  }

  consolidate_systems() {
    return 0;
  }

  all_benefits() {
    return [
      'reduce_time_managing_patient_billing',
      'reduce_time_collecting_posting_payment',
      'reduce_time_reconciling_payment',
      'reduce_time_processing_refunds',
      // 'eliminate_cost_of_merchant_services',
      // 'reduce_cost_of_compliance',
      'improve_payment_collection'
    ];
  }

  improve_operational_efficiency() {
    return this.reduce_time_managing_patient_billing()
      +  this.reduce_time_collecting_posting_payment()
      +  this.reduce_time_reconciling_payment()
      +  this.reduce_time_processing_refunds();
  }

  reduce_costs() {
    return this.eliminate_cost_of_merchant_services()
      + this.reduce_cost_of_compliance();
  }

  dollar_value_of_time_saved() { // ROI Analysis S44
    return this.reduce_time_managing_patient_billing()
      + this.reduce_time_collecting_posting_payment()
      + this.reduce_time_reconciling_payment()
      + this.reduce_time_processing_refunds();
  }

  hourly_blended_salary() { // ROI Analysis S48
    return (this.time_spent_managing_billing() / this.total_hours() * this.fully_burdened_salary(this.annual_billing_staff_salary())
      + this.time_spent_on_payment_collection() / this.total_hours() * this.fully_burdened_salary(this.annual_payment_collecting_staff_salary())
      + this.time_spent_on_payment_reconciliation() / this.total_hours() * this.fully_burdened_salary(this.annual_payment_reconciliation_staff_salary())
      + this.time_spent_processing_refunds() / this.total_hours() * this.fully_burdened_salary(this.annual_refund_processing_staff_salary()))
      / (this.days_worked_per_year() * this.hours_worked_per_day());
  }

  total_hours() { // ROI Analysis S46
    return this.time_spent_managing_billing() //  K22 - 20
      + this.time_spent_on_payment_collection() // K26 - 10
      + this.time_spent_on_payment_reconciliation() // K30 - 10
      + this.time_spent_processing_refunds() // K34 - 1;
  }

  total_annual_investment(year = 1) {
    const recurring_costs = this.effective_rate() * this.processed_dollar_volume_per_month() * 12
      + this.service_package_cost() * this.number_of_offices() * 12
      + this.other_yearly_costs();

      if (year > 1) {
        return recurring_costs;
      }

    // hardware_cost_per_month is now a one-time charge in year 1
    // https://www.pivotaltracker.com/story/show/188753242
    return recurring_costs
      + this.other_one_time_costs()
      + this.hardware_cost_per_month();
  }

  value_forfeited_per_month() {
    return this.total_cumulative_value_for_all_benefits() / 36;
  }
}

export default PmbPracticeSolution;
